import styled from "styled-components";
import { media } from "Utils/breakpoints";

export const NavigationBarStyled = styled.div`
  height: 72px;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  background: #172a3f;
  color: #bbbbbb;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  border-bottom: 1px solid #5e6a79;
  font-family: "Readex Pro", sans-serif;
  font-style: normal;
  user-select: none;
  z-index: 14;
  position: relative;

  /* Narrow portrait phones: the right-hand group (Full / Help / User) runs off
     the edge. Let the bar scroll horizontally so every control is reachable;
     the logo stays pinned (see LogoContainerStyled). */
  ${media.portraitMobile} {
    justify-content: flex-start;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    > * {
      flex-shrink: 0;
    }
  }
`;

export const NavigationBarContainerStyled = styled.div`
  position: relative;

  ${media.tablet} {
    html[data-fullscreen="true"] & {
      display: none;
    }
  }

  /* On StationView at any viewport width, hide the top bar when fullscreen so
     operators get the full vertical real estate. Route attribute is set by
     StationView.tsx; fullscreen attribute is set by FullscreenToggle. */
  html[data-fullscreen="true"][data-route="station"] & {
    display: none;
  }
`;

type LogoContainerStyledProps = {
  isActive: boolean;
};

/* Wraps the logo + its gradient backdrop. In narrow portrait this is the
   pinned (sticky) element; the backdrop sibling sits behind the logo and the
   logo itself stays transparent. */
export const LogoStickyWrapperStyled = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;

  ${media.portraitMobile} {
    position: sticky;
    left: 0;
    z-index: 1;
  }
`;

/* Behind the logo: solid under the glyph, fading to transparent on the right
   so scrolling items dissolve under it. Wider than the logo so the fade lands
   past the glyph, and absolute so it doesn't take flow space. */
export const LogoBackdropStyled = styled.div`
  display: none;

  ${media.portraitMobile} {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 160px;
    height: 100%;
    background: linear-gradient(
      to right,
      #172a3f 0,
      #172a3f 60%,
      transparent 100%
    );
    pointer-events: none;
  }
`;

export const LogoContainerStyled = styled.div<LogoContainerStyledProps>`
  height: 100%;
  display: flex;
  width: 100px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  cursor: ${({ isActive }) => (isActive ? "pointer" : "default")};

  /* Sit above the backdrop; the logo's own background stays transparent. */
  ${media.portraitMobile} {
    position: relative;
    z-index: 1;
  }
`;

export const ContentContainerStyled = styled.div`
  display: flex;
  height: 100%;
  box-sizing: border-box;
  align-items: center;
`;
